// frontend/src/services/presupuestosService.js
import apiPresupuestos from './apiPresupuestos';

const presupuestosService = {
  // Equipos
  getEquipos: () => apiPresupuestos.get('presupuestos/equipos/'),
  createEquipo: (data) => apiPresupuestos.post('presupuestos/equipos/', data),
  updateEquipo: (id, data) => apiPresupuestos.patch(`presupuestos/equipos/${id}/`, data),
  deleteEquipo: (id) => apiPresupuestos.delete(`presupuestos/equipos/${id}/`),

  // Proveedores
  getProveedores: () => apiPresupuestos.get('presupuestos/proveedores/'),
  createProveedor: (data) => apiPresupuestos.post('presupuestos/proveedores/', data),
  updateProveedor: (id, data) => apiPresupuestos.patch(`presupuestos/proveedores/${id}/`, data),
  deleteProveedor: (id) => apiPresupuestos.delete(`presupuestos/proveedores/${id}/`),

  // Areas
  getAreas: () => apiPresupuestos.get('presupuestos/areas/'),
  createArea: (data) => apiPresupuestos.post('presupuestos/areas/', data),
  updateArea: (id, data) => apiPresupuestos.patch(`presupuestos/areas/${id}/`, data),
  deleteArea: (id) => apiPresupuestos.delete(`presupuestos/areas/${id}/`),

  // Partidas
  getPartidas: () => apiPresupuestos.get('presupuestos/partidas/'),
  createPartida: (data) => apiPresupuestos.post('presupuestos/partidas/', data),
  updatePartida: (id, data) => apiPresupuestos.patch(`presupuestos/partidas/${id}/`, data),
  deletePartida: (id) => apiPresupuestos.delete(`presupuestos/partidas/${id}/`),

  // Recursos
  getRecursos: () => apiPresupuestos.get('presupuestos/recursos/'),
  createRecurso: (data) => apiPresupuestos.post('presupuestos/recursos/', data),
  updateRecurso: (id, data) => apiPresupuestos.patch(`presupuestos/recursos/${id}/`, data),
  deleteRecurso: (id) => apiPresupuestos.delete(`presupuestos/recursos/${id}/`),

  // Presupuestos
  getPresupuestos: () => {
    return apiPresupuestos.get('presupuestos/presupuestos/').then(res => {
      console.log('📊 getPresupuestos response data:', res.data, 'is Array?', Array.isArray(res.data));
      return res;
    }).catch(err => {
      console.error('❌ Error en getPresupuestos:', err);
      throw err;
    });
  },
  getPresupuestosByPeriodo: (periodo) => {
    return apiPresupuestos.get(`presupuestos/presupuestos/by_periodo/?periodo=${periodo}`).then(res => {
      console.log(`📊 getPresupuestosByPeriodo(${periodo}) response data:`, res.data, 'is Array?', Array.isArray(res.data));
      return res;
    }).catch(err => {
      console.error(`❌ Error en getPresupuestosByPeriodo(${periodo}):`, err);
      throw err;
    });
  },
  getPresupuestosByEquipo: (equipoId) =>
    apiPresupuestos.get(`presupuestos/presupuestos/by_equipo/?equipo=${equipoId}`),
  createPresupuesto: (data) => apiPresupuestos.post('presupuestos/presupuestos/', data),
  updatePresupuesto: (id, data) => apiPresupuestos.patch(`presupuestos/presupuestos/${id}/`, data),
  deletePresupuesto: (id) => apiPresupuestos.delete(`presupuestos/presupuestos/${id}/`),
  addAreaToPresupuesto: (presupuestoId, areaId) =>
    apiPresupuestos.post(`presupuestos/presupuestos/${presupuestoId}/add_area/`, { area_id: areaId }),
  removeAreaFromPresupuesto: (presupuestoId, areaId) =>
    apiPresupuestos.post(`presupuestos/presupuestos/${presupuestoId}/remove_area/`, { area_id: areaId }),
  changePresupuestoStatus: (presupuestoId, newStatus) =>
    apiPresupuestos.post(`presupuestos/presupuestos/${presupuestoId}/change_status/`, { status: newStatus }),
  approvePresupuesto: (presupuestoId) =>
    apiPresupuestos.post(`presupuestos/presupuestos/${presupuestoId}/approve_presupuesto/`),
  rejectPresupuesto: (presupuestoId) =>
    apiPresupuestos.post(`presupuestos/presupuestos/${presupuestoId}/reject_presupuesto/`),

  // Órdenes de Compra
  getOrdenesCompra: () => apiPresupuestos.get('presupuestos/ordenes-compra/'),
  createOrdenCompra: (data) => apiPresupuestos.post('presupuestos/ordenes-compra/', data),
  updateOrdenCompra: (id, data) => apiPresupuestos.patch(`presupuestos/ordenes-compra/${id}/`, data),
  deleteOrdenCompra: (id) => apiPresupuestos.delete(`presupuestos/ordenes-compra/${id}/`),
  getOrdenesCompraPorPresupuesto: (presupuestoId) =>
    apiPresupuestos.get(`presupuestos/ordenes-compra/by_presupuesto/?presupuesto_id=${presupuestoId}`),
  getOrdenesCompraPorRecurso: (recursoId) =>
    apiPresupuestos.get(`presupuestos/ordenes-compra/by_recurso/?recurso_id=${recursoId}`),
  getDisponibilidadRecurso: (recursoId, queryParams) =>
    apiPresupuestos.get(`presupuestos/ordenes-compra/disponibilidad_recurso/?${queryParams || `recurso_id=${recursoId}`}`),
  cambiarStatusOrdenCompra: (ocId, nuevoStatus) =>
    apiPresupuestos.post(`presupuestos/ordenes-compra/${ocId}/cambiar_status/`, { status: nuevoStatus }),
};

export default presupuestosService;
